import React from 'react';
import {FormSwitchFieldProps} from '../../../@types/components/Form';
import {CheckboxField} from './index';
import classnames from '../../../helpers/classnames';
import {IEmptyModel} from '../../../@interfaces/IEmptyModel';

export default function SwitchField<Model extends IEmptyModel>(props: FormSwitchFieldProps<Model>) {
    const size = props.config.size ?? 'md';

    return <CheckboxField {...props} className={classnames({
        'form-switch': true,
        [`form-switch-${size}`]: size
    })}/>;
}
